import { cva, type VariantProps } from 'class-variance-authority';
import { uiMarker } from './shared';

/**
 * CHART LEGEND
 *
 * The key beside a chart: a swatch per series and its name. The swatch is
 * painted from the same `--chart-N` token the series is drawn with, so the
 * key and the line cannot disagree. Written out per series for the usual
 * reason — Tailwind reads class names from source, and `bg-chart-${n}`
 * produces nothing.
 *
 * `area` is a filled block, `line` a thin rule: the two marks a chart draws,
 * so a reader can tell the filled series from the line riding above it.
 */
export const chartSwatchRecipe = cva(
  [uiMarker, 'inline-block w-4 shrink-0 rounded-sm'],
  {
    variants: {
      series: {
        1: 'bg-chart-1',
        2: 'bg-chart-2',
        3: 'bg-chart-3',
        4: 'bg-chart-4',
        5: 'bg-chart-5',
      },
      mark: {
        area: 'h-2',
        line: 'h-0.5',
      },
    },
    defaultVariants: { series: 1, mark: 'area' },
  }
);

export type ChartSwatchRecipeProps = VariantProps<typeof chartSwatchRecipe>;
